import { Button, Col, Row, Form } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { TemplateModel, UsersAccountsModel } from "../../types/CommonModel";
import { getCustomerData, getTemplateData } from "../../api/commonApi";
import { EmailTemplateReq } from "../../types/EmailTemplateModel";
import {
  AddTemplate,
  EmailTemplateUpdate,
  GetEmailTemplateById,
  GetTemplateGroup,
} from "../../api/emailTemplateApi/emailTemplateApi";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

const EmailTemplateAction = () => {
  const { showSnackbar } = useSnackbar();
  const location = useLocation();
  const [action, setAction] = useState<string>(location.state?.action || {});
  const rowData = location.state?.rowData || {};
  const [data, setData] = useState<any>([]);
  const { setLoading } = useLoader();
  const [customer, setCustomer] = useState<any>([]);
  const [template, setTemplate] = useState<any>([]);
  const [templateGroup, setTemplateGroup] = useState<any>([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [emailTemplateId, setEmailTemplateId] = useState<number>(0);
  const navigate = useNavigate();
  const [formData, setFormData] = useState<{
    customerId?: number | "";
    templateName?: string;
    templateId?: number | "";
    description?: string;
    groupName?: string;
    groupNameId?: number | "";
    templateDefinationTo?: string;
    templateDefinationCc?: string;
    templateDefinationSubject?: string;
    templateDefinationBody?: string;
    additionalNotes?: string;
    messageBody?: string;
  }>({});
  type errorModel = {
    templateNameError?: string;
    descriptionError?: string;
    templateDefinationToError?: string;
    templateDefinationSubjectError?: string;
    templateDefinationBodyError?: string;
  };
  const [errors, setErrors] = useState<errorModel>({});

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setErrors({
      templateNameError: "",
      descriptionError: "",
      templateDefinationToError: "",
      templateDefinationSubjectError: "",
      templateDefinationBodyError: "",
    });
    setValidation();
  };

  const setValidation = () => {
    const error: errorModel = {
      templateNameError: "",
      descriptionError: "",
      templateDefinationToError: "",
      templateDefinationSubjectError: "",
      templateDefinationBodyError: "",
    };
    if (formData.templateId === undefined || formData.templateId === 0) {
      error.templateNameError = "Please select the template name";
    }
    if (formData.description === undefined || formData.description === "") {
      error.descriptionError = "Please enter description";
    }
    if (
      formData.templateDefinationTo === undefined ||
      formData.templateDefinationTo === ""
    ) {
      error.templateDefinationToError = "Please enter email";
    } else if (formData.templateDefinationTo !== "") {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.exec(formData.templateDefinationTo)) {
        error.templateDefinationToError = "Please enter valid email";
      }
    }
    if (
      formData.templateDefinationSubject === undefined ||
      formData.templateDefinationSubject === ""
    ) {
      error.templateDefinationSubjectError = "Please enter Subject";
    }
    if (formData.messageBody === undefined || formData.messageBody === "") {
      error.templateDefinationBodyError = "Please enter body message";
    }

    if (
      error.descriptionError !== "" ||
      error.templateDefinationBodyError !== "" ||
      error.templateDefinationSubjectError !== "" ||
      error.templateDefinationToError !== "" ||
      error.templateNameError !== ""
    ) {
      setErrors(error);
    } else {
      // Proceed with form submission or other logic
      setErrors({});
      addTemplate();
    }
  };

  const addTemplate = async () => {
    if (action === "Edit") {
      const payload: any = {
        EmailTemplateId:
          emailTemplateId === 0 ? rowData.emailTemplateId : emailTemplateId,
        Description: formData.description ?? "",
        ToEmail: formData.templateDefinationTo ?? "",
        CCEmail: formData.templateDefinationCc ?? "",
        Subject: formData.templateDefinationSubject ?? "",
        MessageBody: formData.messageBody ?? "",
        Signature: "",
        AdditionalNotes: formData.additionalNotes ?? "",
        AccountID: Number(LocalStorageUtil.getItem("accountId")),
        TemplateName: formData.templateName ?? "",
        TemplateType: Number(formData.templateId) || 0,
        Active: true,
        contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
        EmailTemplateGroupId: formData.groupNameId ?? 0,
        EmailTemplateGroupName: formData.groupName ?? "",
      };

      const response = await EmailTemplateUpdate(payload);
      if (response) {
        navigate("/email");
        showSnackbar("Email Template Updated Successfully");
      } else {
        showSnackbar("Template already exist", true);
      }
    } else {
      const payload: any = {
        TemplateName: formData.templateName ?? "",
        TemplateType: Number(formData.templateId) || 0,
        Description: formData.description ?? "",
        ToEmail: formData.templateDefinationTo ?? "",
        CCEmail: formData.templateDefinationCc ?? "",
        Subject: formData.templateDefinationSubject ?? "",
        MessageBody: formData.messageBody ?? "",
        Signature: "",
        AdditionalNotes: formData.additionalNotes ?? "",
        Active: true,
        businessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
        createdby: Number(LocalStorageUtil.getItem("userId")),
        contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
        EmailTemplateGroupName: formData.groupName ?? "",
      };

      const response = await AddTemplate(payload);
      if (response) {
        navigate("/email");
        showSnackbar("Email Template Created Successfully");
      } else {
        showSnackbar("Email template already inserted", true);
      }
    }
  };

  useEffect(() => {
    getCustomer();
    getTemplate();
    getTemplateDataById();
    setFormData({
      customerId: Number(LocalStorageUtil.getItem("businessUnitId")),
      additionalNotes: "",
      description: "",
      groupName: "",
      groupNameId: "",
      templateDefinationBody: "",
      templateDefinationCc: "",
      templateDefinationSubject: "",
      templateDefinationTo: "",
      templateId: 0,
      templateName: "",
      messageBody: "",
    });
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      setFormData({
        customerId: Number(LocalStorageUtil.getItem("businessUnitId")),
        additionalNotes: data[0]?.additionalNotes ?? "",
        description: data[0]?.description ?? "",
        groupName: data[0]?.emailTemplateGroupName ?? "",
        groupNameId: data[0]?.emailTemplateGroupId ?? "",
        templateDefinationCc: data[0]?.ccEmail ?? "",
        templateDefinationSubject: data[0]?.subject ?? "",
        templateDefinationTo: data[0]?.toEmail ?? "",
        templateId: data[0]?.templateType ?? 0,
        templateName: data[0]?.templateName ?? "",
        messageBody: stripHtmlTags(data[0]?.messageBody) ?? "",
      });
    }
  }, [data, rowData]);

  const stripHtmlTags = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent ?? "";
  };

  const getTemplateDataById = async () => {
    const payload: EmailTemplateReq = {
      contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
      emailTemplateId: rowData.emailTemplateId,
      templateTypeId: 0,
    };
    const data = await GetEmailTemplateById(payload);
    setData(data);
  };

  const getCustomer = async () => {
    setLoading(true);
    const payload: UsersAccountsModel = {
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      isSuperAdmin: 1,
      primaryGroupId: 1,
      userId: parseInt(LocalStorageUtil.getItem("userId") ?? "0"),
    };
    try {
      const data = await getCustomerData(payload);
      setCustomer(data);
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  const getTemplate = async () => {
    setLoading(true);
    const payload: TemplateModel = {
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      businessUnitId: Number(LocalStorageUtil.getItem("businessUnitId") ?? 0),
      templateType: "0",
    };
    try {
      const data = await getTemplateData(payload);
      setTemplate(data);
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  const getTemplateGroup = async (args: number) => {
    setLoading(true);
    const payload: EmailTemplateReq = {
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      templateTypeId: args,
    };
    try {
      const data = await GetTemplateGroup(payload);
      setTemplateGroup(data);
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const templateId = Number(event.target.value);
    const templateName =
      event.target.options[event.target.selectedIndex].innerText;
    setFormData((prevState) => ({
      ...prevState,
      templateId: Number(event.target.value),
      templateName: event.target.options[event.target.selectedIndex].innerText,
    }));
    const payload: any = {
      contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
      templateTypeId: Number(event.target.value),
      EmailTemplateGroupId: 0,
    };
    const data = await GetEmailTemplateById(payload);
    if (data.length > 0) {
      setAction("Edit");
      setEmailTemplateId(data[0]?.emailTemplateId);
      setFormData({
        customerId: Number(LocalStorageUtil.getItem("businessUnitId")),
        additionalNotes: data[0]?.additionalNotes ?? "",
        description: data[0]?.description ?? "",
        groupName: data[0]?.emailTemplateGroupName ?? "",
        groupNameId: data[0]?.emailTemplateGroupId ?? "",
        templateDefinationCc: data[0]?.ccEmail ?? "",
        templateDefinationSubject: data[0]?.subject ?? "",
        templateDefinationTo: data[0]?.toEmail ?? "",
        templateId: data[0]?.templateType ?? 0,
        templateName: data[0]?.templateName ?? "",
        messageBody: stripHtmlTags(data[0]?.messageBody) ?? "",
      });
    } else {
      setAction("");
      setEmailTemplateId(0);
      setFormData({
        customerId: Number(LocalStorageUtil.getItem("businessUnitId")),
        additionalNotes: "",
        description: "",
        groupName: "",
        groupNameId: "",
        templateDefinationBody: "",
        templateDefinationCc: "",
        templateDefinationSubject: "",
        templateDefinationTo: "",
        templateId: templateId,
        templateName: templateName ?? "",
        messageBody: "",
      });
    }
    getTemplateGroup(templateId);
  };

  const handleDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      description: event.target.value,
    }));
  };

  const handleMessageBodyChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      messageBody: event.target.value,
    }));
  };

  const handleGroupNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      groupName: event.target.value,
    }));
  };

  const handleGroupChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      groupNameId: Number(event.target.value),
    }));

    const payload: any = {
      contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
      templateTypeId: formData.templateId,
      EmailTemplateGroupId:
        event.target.value === "" ? null : Number(event.target.value),
    };
    const data = await GetEmailTemplateById(payload);
    if (data.length > 0) {
      setAction("Edit");
      setEmailTemplateId(data[0]?.emailTemplateId);
      setFormData({
        customerId: Number(LocalStorageUtil.getItem("businessUnitId")),
        additionalNotes: data[0]?.additionalNotes ?? "",
        description: data[0]?.description ?? "",
        groupName: data[0]?.emailTemplateGroupName ?? "",
        groupNameId: data[0]?.emailTemplateGroupId ?? "",
        templateDefinationCc: data[0]?.ccEmail ?? "",
        templateDefinationSubject: data[0]?.subject ?? "",
        templateDefinationTo: data[0]?.toEmail ?? "",
        templateId: data[0]?.templateType ?? 0,
        templateName: data[0]?.templateName ?? "",
        messageBody: stripHtmlTags(data[0]?.messageBody) ?? "",
      });
    }
  };

  const handleToEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevState) => ({
      ...prevState,
      templateDefinationTo: event.target.value,
    }));
  };

  const handleCcEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevState) => ({
      ...prevState,
      templateDefinationCc: event.target.value,
    }));
  };

  const handleSubjectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevState) => ({
      ...prevState,
      templateDefinationSubject: event.target.value,
    }));
  };

  const handleAdditionalNotesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      additionalNotes: event.target.value,
    }));
  };

  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  //Close the dialog box after confirmation
  const handleConfirmDialogClose = (confirm: boolean) => {
    setConfirmDialogOpen(false);
    if (confirm) {
      // Add your logic here if needed
      navigate("/email"); // Redirect to FileLocation
    } else {
      setConfirmDialogOpen(false);
    }
  };

  return (
    <div>
      {action === "Edit" ? (
        <NavigationBar  menuTitle="Configuration" title="Email Template" text="Email Template - Update" />
      ) : (
        <NavigationBar
          menuTitle="Configuration"
          title="Email Template"
          text="Email Template - Create New"
        />
      )}
      <div className="ag-theme-quartz-dark" style={{ margin: "2em" }}>
        <Form>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Customer
                </Form.Label>
                <Form.Select
                  name="customerId"
                  value={formData.customerId}
                  disabled
                  className="select-dropdown" style={{fontSize: "11px"}}
                >
                  <option value="">Select</option>
                  {customer.map((customer: any) => (
                    <option
                      key={customer.businessUnitId}
                      value={customer.businessUnitId}
                    >
                      {customer.accountName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Template Name<span
                    style={{ color: "var(--aggrid-text-color)" }}
                    className="required"
                  >
                    *
                  </span>
                </Form.Label>
                <Form.Select
                  required
                  isInvalid={!!errors.templateNameError}
                  value={formData.templateId}
                  onChange={handleTemplateChange}
                  className="select-dropdown" style={{fontSize: "11px"}}
                >
                  <option value="0">Select</option>
                  {template.map((template: any) => (
                    <option
                      key={template.templateTypeName}
                      value={template.templateTypeId}
                    >
                      {template.templateTypeName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.templateNameError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Description<span
                    style={{ color: "var(--aggrid-text-color)" }}
                    className="required"
                  >
                    *
                  </span>
                </Form.Label>
                <Form.Control
                  data-testid="description"
                  as="textarea"
                  rows={3}
                  placeholder="Enter description here"
                  name="description"
                  value={formData.description}
                  onChange={handleDescriptionChange}
                  isInvalid={!!errors.descriptionError}
                  required style={{fontSize: "11px"}}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descriptionError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}
                >
                  Group Name
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please enter the Group Name"
                  name="groupName"
                  value={formData.groupName}
                  onChange={handleGroupNameChange}
                  required
                  className="input-box" style={{fontSize: "11px"}}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Select Group Name
                </Form.Label>
                <Form.Select
                  name="groupId"
                  value={formData.groupNameId}
                  onChange={handleGroupChange}
                  className="select-dropdown" style={{fontSize: "11px"}}
                >
                  <option value="">--Select Group Name--</option>
                  {templateGroup.map((templateGroup: any) => (
                    <option
                      key={templateGroup.emailTemplateGroupId}
                      value={templateGroup.emailTemplateGroupId}
                    >
                      {templateGroup.emailTemplateGroupName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <h4
            className="form-heading"
            style={{ color: "var(--aggrid-text-color)",fontSize: "12px" }}
          >
            TEMPLATE DEFINATION
          </h4>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  To<span
                    style={{ color: "var(--aggrid-text-color)" }}
                    className="required"
                  >
                    *
                  </span>
                </Form.Label>
                <Form.Control
                  data-testid="toEmail"
                  type="email"
                  placeholder="user@email.com"
                  name="to"
                  value={formData.templateDefinationTo ?? ""}
                  onChange={handleToEmailChange}
                  required
                  isInvalid={!!errors.templateDefinationToError}
                  className="input-box" style={{fontSize: "11px"}}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.templateDefinationToError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  CC
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="user@email.com"
                  name="cc"
                  value={formData.templateDefinationCc ?? ""}
                  onChange={handleCcEmailChange}
                  className="input-box" style={{fontSize: "11px"}}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Subject<span
                    style={{ color: "var(--aggrid-text-color)" }}
                    className="required"
                  >
                    *
                  </span>
                </Form.Label>
                <Form.Control
                  type="subject"
                  placeholder="Enter the Subject"
                  name="subject"
                  value={formData.templateDefinationSubject ?? ""}
                  onChange={handleSubjectChange}
                  required
                  isInvalid={!!errors.templateDefinationSubjectError}
                  className="input-box" style={{fontSize: "11px"}}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.templateDefinationSubjectError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}
                >
                  <b>Body</b>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter description here"
                  name="messageBody"
                  value={formData.messageBody}
                  onChange={handleMessageBodyChange}
                  isInvalid={!!errors.descriptionError}
                  required style={{fontSize: "11px"}}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.templateDefinationBodyError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Additional Notes
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter Additional notes here"
                  name="additionalNote"
                  value={formData.additionalNotes}
                  onChange={handleAdditionalNotesChange}
                  required style={{fontSize: "11px"}}
                />
              </Form.Group>
            </Col>
          </Row>
          <div
            style={{
              width: "98%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "16px",
              marginBottom: "15px",
            }}
          >
            {action === "Edit" ? (
              <Button
                variant="contained"
                onClick={handleSubmit}
                className="update-button"
              >
                Update
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                className="update-button"
                onClick={handleSubmit}
                
              >
                Create
              </Button>
            )}
            <Button
              className="cancel-button"
              onClick={handelCancel}             
            >
              Cancel
            </Button>
          </div>
        </Form>
        <Dialog
          open={confirmDialogOpen}
          onClose={() => handleConfirmDialogClose(false)}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle
            style={{
              backgroundColor: "var(--primary-color)",
              color: "var(--aggrid-text-color)",
              fontSize: "14px",
            }}
          >
            Email Template - {action === "Edit" ? "Save" : "Create New"}{" "}
          </DialogTitle>
          <DialogContent style={{ fontSize: "14px", marginTop: "20px" }}>
            Are you sure you want to Cancel?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleConfirmDialogClose(true)}
              color="primary"
              className="dialog-button"
            >
              Yes
            </Button>
            <Button
              onClick={() => handleConfirmDialogClose(false)}
              color="primary"
              className="dialog-button"
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default EmailTemplateAction;
